module.exports = __webpack_public_path__ + "img/metros_totales.7d9eb676.svg";